import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PacksSection from "@/components/PacksSection";
import { UNIT_SERVICES } from "@/data/content";

export default function OffresPage() {
  return (
    <div data-testid="offres-page">
      {/* Packs */}
      <section className="bg-slate-50 py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-14">
            <p className="text-sm font-semibold text-green-600 uppercase tracking-wider mb-3">Nos packs</p>
            <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-slate-900">
              Des packs clairs pour une image professionnelle
            </h1>
            <p className="mt-5 text-lg text-slate-600 leading-relaxed">
              Choisissez le pack adapté à votre projet. Pas sûr ? Le diagnostic gratuit vous
              oriente vers l'offre la plus pertinente pour votre situation.
            </p>
            <Link
              to="/diagnostic"
              data-testid="offres-diagnostic-link"
              className="mt-8 inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white rounded-xl px-7 py-3.5 font-semibold transition-colors shadow-sm"
            >
              Faire le diagnostic gratuit <ArrowRight size={20} />
            </Link>
          </div>
          <PacksSection />
        </div>
      </section>

      {/* Prestations à l'unité */}
      <section className="bg-white py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-14">
            <p className="text-sm font-semibold text-green-600 uppercase tracking-wider mb-3">À la carte</p>
            <h2 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">
              Prestations à l'unité
            </h2>
            <p className="mt-4 text-lg text-slate-600 leading-relaxed">
              Besoin d'un seul service ? Commandez exactement ce qu'il vous faut, sans engagement.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {UNIT_SERVICES.map((s, i) => {
              const Icon = s.icon;
              return (
                <div
                  key={i}
                  data-testid={`unit-service-${i}`}
                  className="flex items-start gap-4 rounded-2xl border border-slate-100 bg-white shadow-sm p-6 hover:shadow-md transition-shadow"
                >
                  <span className="shrink-0 inline-flex items-center justify-center h-11 w-11 rounded-xl bg-green-50 text-green-600">
                    <Icon size={22} />
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-baseline justify-between gap-2">
                      <h3 className="font-heading font-semibold text-slate-900">{s.name}</h3>
                      <span className="font-heading font-bold text-green-600 whitespace-nowrap">{s.price}</span>
                    </div>
                    <p className="text-sm text-slate-500 mt-1">{s.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="mt-12 text-center">
            <p className="text-slate-500 max-w-2xl mx-auto mb-6">
              Un projet sur mesure ou une combinaison particulière ? Parlons-en, on s'adapte à vos besoins.
            </p>
            <Link
              to="/contact"
              data-testid="offres-contact-link"
              className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white rounded-xl px-7 py-3.5 font-semibold transition-colors shadow-sm"
            >
              Demander un devis <ArrowRight size={20} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
